import { render, staticRenderFns } from "./PaginationTpl.vue?vue&type=template&id=c377945a&scoped=true&"
import script from "./PaginationTpl.vue?vue&type=script&lang=js&"
export * from "./PaginationTpl.vue?vue&type=script&lang=js&"
import style0 from "./PaginationTpl.vue?vue&type=style&index=0&id=c377945a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c377945a",
  null
  
)

export default component.exports